import type { ChangeEvent, ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { SpaceProps } from 'styled-system';
import { space } from 'styled-system';

import { OutlineSelect } from 'common/components/Select';
import { useLocalization } from 'common/providers/LocaleProvider';
import { swallowEnter } from 'common/utils/keyboard';
import type { AddToCartProps } from '../components/types';

interface QuantityProps extends Pick<AddToCartProps, 'selectWidth'> {
  value: string;
  options: number[];
  onSelect: (params: ChangeEvent<HTMLSelectElement>) => void;
  isHidden: boolean;
  isDisabled: boolean;
  className?: string;
}

const UnstyledContainer = styled.div<SpaceProps>`
  ${space};
`;

const Container = (props: ComponentProps<typeof UnstyledContainer>) => (
  <UnstyledContainer pr={['sp_16', null, 'sp_8', 'sp_16']} {...props} />
);

const Quantity = ({
  value,
  options,
  onSelect,
  selectWidth,
  isHidden,
  isDisabled,
}: QuantityProps) => {
  const { t } = useLocalization();

  if (isHidden) {
    return null;
  }

  return (
    <Container>
      <OutlineSelect
        name="qty"
        aria-label={t('h24_accessibility_select_qty')}
        title={t('quantity')}
        value={value}
        options={options}
        onSelect={onSelect}
        width={selectWidth}
        disabled={isDisabled}
        onKeyDown={swallowEnter}
      />
    </Container>
  );
};

export default Quantity;
